import React from 'react';

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="flex justify-center mb-6 space-x-4">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onSelectCategory(category)}
          className={`px-4 py-2 rounded-md ${
            selectedCategory === category
              ? 'bg-blue-600 text-white'
              : 'bg-gray-700 text-gray-300'
          } hover:bg-blue-500 transition-all`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
